module.exports = __webpack_public_path__ + "static/media/Name items.10f27438.mp3";